var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"scroll-spy",rawName:"v-scroll-spy",value:({data: 'section'}),expression:"{data: 'section'}"}],attrs:{"id":"view-container"}},[_c('Home'),_c('About'),_c('Gallery'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }